import { useNavigate, useParams } from "react-router-dom";
import { ExpensePolicyDocumentPage as ExpensePolicyDocumentPageView } from "@/components/ExpensePolicyDocumentPage";

export function ExpensePolicyDocumentPage() {
  const { documentId } = useParams<{ documentId: string }>();
  const navigate = useNavigate();

  if (!documentId) return null;

  return (
    <ExpensePolicyDocumentPageView
      documentId={documentId}
      onBack={() => navigate("/expenses/approval-policies")}
      onConfirmed={() => navigate("/expenses/approval-policies")}
    />
  );
}
